import React from 'react';
import { Layout, Row, Col } from 'antd';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import style from './../Footer.module.less';
import { getTenantConfig } from '@/utils/tenantConfig';

// Images
import { FOOTER_LINKS } from '@/config/constants/boat';
import SubFooter from './SubFooter';

const Footer = () => {
  const { logoDark } = getTenantConfig();

  return (
    <Layout.Footer className={style.footer}>
      <Row>
        <Col lg={9} sm={12} xs={24} className={style.footerLogo}>
          <Link to="/">
            <img className={style.homeLogo} src={logoDark} alt="Let's Camp Reservation System" width='316px' />
          </Link>
          <div className={style.about}>
            <p>
              <FormattedMessage defaultMessage="Let's Boat connects boaters with marinas. Find and book your new favorite spot with our intuitive search and booking tools. Marinas can take advantage of our user-friendly tools to better manage their bookings and generate more revenue for their business." />
            </p>
          </div>
        </Col>
        <Col lg={5} sm={12} xs={24} className={style.footerSection}>
          <p className={style.title}>
            <FormattedMessage defaultMessage="For Boaters" />
          </p>
          <Link to="/marinas">
            <FormattedMessage defaultMessage="Find a Marina" />
          </Link>
          <a href={FOOTER_LINKS.faq}>
            <FormattedMessage defaultMessage="Boater FAQ" />
          </a>
          <Link to="/contact">
            <FormattedMessage defaultMessage="Contact Us" />
          </Link>
        </Col>
        <Col lg={5} sm={12} xs={24} className={style.footerSection}>
          <p className={style.title}>
            <FormattedMessage defaultMessage="For Marinas" />
          </p>
          <Link to="/marina-sign-up">
            <FormattedMessage defaultMessage="Register My Marina" />
          </Link>
          <a href={FOOTER_LINKS.about}>
            <FormattedMessage defaultMessage="About Let's Boat" />
          </a>
          <a href={FOOTER_LINKS.marinaSupport}>
            <FormattedMessage defaultMessage="Support" />
          </a>
        </Col>
        <Col lg={5} sm={12} xs={24} className={style.footerSection}>
          <p className={style.title}>
            <FormattedMessage defaultMessage="Get Social" />
          </p>
          <div className={style.socialIcons}>
            <p>#letsboat</p>
          </div>
        </Col>
      </Row>

      <hr />

      <SubFooter />
    </Layout.Footer>
  );
};

export default Footer;
